import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Route, Switch, Redirect } from 'react-router';
import queryString from 'query-string';

import FrontPage from '../containers/front-page';

import PressRoute from './press-route';
import PressKitRoute from './press-kit-route';
import SpecialistsRoute from './specialists-route';
import PressNewsRoute from './press-news-route';
//
import AboutUsRoute from './about-us-route';
import CompanyRoute from './company-route';
import LeadershipRoute from './leadership-route';
import CareersRoute from './careers-route';
import DepartmentRoute from './department-route';
import JobRoute from './job-route';
import Container from './container';

const appFrom = (Component) => (props) => {
  const newProps = { analyticsName: Component.analyticsName, ...props };
  return (
    <Container {...newProps}>
      <Component />
    </Container>
  );
};

const Routes = ({ navV2, isSignedIn }) => (
  <Switch>
    <Route
      exact
      path="/"
      render={(props) => {
        const { location } = props;
        if (isSignedIn && !navV2) {
          const loggedInRedirectQueryParams = {
            ...queryString.parse(location.search || ''),
            trk: 'nw_hp',
          };
          const loggedInRedirect = {
            pathname: '/home/dashboard/home',
            search: queryString.stringify(loggedInRedirectQueryParams),
          };
          return <Redirect to={loggedInRedirect} />;
        }
        const App = appFrom(FrontPage);
        return <App {...props} />;
      }}
    />
    <Route path="/about-us" component={appFrom(AboutUsRoute)} />
    <Route path="/press" component={appFrom(PressRoute)} />
    <Route path="/kit" component={appFrom(PressKitRoute)} />
    <Route path="/specialists" component={appFrom(SpecialistsRoute)} />
    <Route path="/news" component={appFrom(PressNewsRoute)} />
    <Route path="/company" component={appFrom(CompanyRoute)} />
    <Route path="/leadership" component={appFrom(LeadershipRoute)} />
    <Route path="/careers" exact component={appFrom(CareersRoute)} />
    <Route
      path="/careers/job/:id"
      // if job URL contains *only* a greenhouse gh_src tracking id in the query string (ie: no gh_jid), add a gh_jid value to the redirect URL and then redirect to that built URL
      render={(props) => {
        const { location, match } = props;
        const rawQueryString = location.search;
        const oneGreenhouseSrcParam =
          rawQueryString &&
          rawQueryString.includes('gh_src=') &&
          !rawQueryString.includes('gh_jid=');

        if (oneGreenhouseSrcParam) {
          const appendJobIdQueryString = {
            ...queryString.parse(location.search),
            gh_jid: match.params.id,
          };
          const jobIdAddedToRedirectUrl = {
            pathname: location.pathname,
            search: queryString.stringify(appendJobIdQueryString),
          };
          return <Redirect to={jobIdAddedToRedirectUrl} />;
        }
        const App = appFrom(JobRoute);
        return <App {...props} />;
      }}
    />
    <Route path="/careers/:slug" component={appFrom(DepartmentRoute)} />
  </Switch>
);

Routes.propTypes = {
  isSignedIn: PropTypes.bool,
  navV2: PropTypes.bool,
  location: PropTypes.object,
  match: PropTypes.object,
  relativePath: PropTypes.object,
};

const WrappedRoutes = connect((state) => ({
  isSignedIn: _.get(state, 'identity.isSignedIn', false),
  navV2: _.get(state, 'featureFlags.nav_v2.value', false),
}))(Routes);

WrappedRoutes.displayName = 'Wrapped Routes';

export default WrappedRoutes;
